<template>
	<div>
			<div class="navbar-item">
			<div class="field  ">
						<p class="control" style="margin:5px">
							<!--<a class="paddinglogo" href="https://www.wewamart.com/"> 
             					<img id="logo" src="@/assets/logo.png" alt=""/>
               				</a>-->
							<!--<a v-if="!isUserLoggedIn" class="button" @click="showSignupModal">
								<router-link to="/shoppingcart">
									<span class="icon">
										<i class="fas fa-user-plus"></i>
									</span>
									<span>{{ signupLabel }}</span>
								</router-link>
							</a>&nbsp-->
							<a v-if="!isUserLoggedIn" class="button" @click="showLoginModal">
								<router-link to="/login">
									<span style="font-size: 1em; color: black;">
										<i class="fas fa-user"></i>
									</span>
									<span  style="font-size: 1em; color: black;">{{ loginLabel }}</span>
								</router-link>
							</a>
							&nbsp
		
							<a class="navbar-item" style="color:black"> 
								<span style="font-size: 1em; color: black;">
						 			<a v-if="this.$store.getters.cartQty > 0">
										<router-link to="/cartitem">
											<i class="fas fa-cart-plus"></i>
										</router-link>
									</a>
									<a v-else> 
										<i class="fas fa-shopping-cart"></i>
									</a>
								</span>
								<span style="font-size: 1em; color: black;" :class="[numProductsAdded > 0 ? 'tag is-info' : '']">({{ numProductsAdded }})&nbsp&nbsp</span>
							</a>

							<a v-if="isUserLoggedIn" class="button" @click="logout">
								<router-link to="/home">
									<span  style="font-size: 1em; color: black;">
										<i class="fas fa-sign-out-alt"></i>
									</span>
									<span  style="font-size: 1em; color: black;">{{ logoutLabel }}</span>
								</router-link>
							</a>

						</p>
				
			</div>
		</div>
<!--		
		<div v-if="isUserLoggedIn" class="navbar-item" style="color:black">
			<a class="navbar-link">
				Welcome {{ getUserName }}
			</a>
		  	<div class="field">	
			  <p class="control" style="margin:5px">				   
				<span style="font-size: 1em; color: black;">
					<i class="fas fa-shopping-cart"></i>
				</span>
				<span style="font-size: 1em; color: black;" :class="[numProductsAdded > 0 ? 'tag is-info' : '']">({{ numProductsAdded }})</span>

				<div class="button" @click="logout">
					<router-link to="/home">
						<span class="icon">
							<i class="fas fa-sign-out-alt"></i>
						</span>
						<span>{{ logoutLabel }}</span>
					</router-link>	
				</div>
			  </p>
		  	</div>
		</div>
-->
	</div>
</template>

<script>
import firebase from 'firebase'

export default {
	name: 'signinlogin',
	data () {
		return {
			logoutLabel: 'Log out',
			loginLabel: 'Log in',
			signupLabel: 'Sign up'
		}
	},

	computed: {
		isUserLoggedIn () {
			return this.$store.getters.isUserLoggedIn;
		},
		getUserName () {
			let name = this.$store.getters.getUserName;
			
			if (name === '') {
				return 'user';
			} else {
				return name;
			}
		},
		numProductsAdded () {  //18-dec
        return this.$store.getters.cartQty;
      }
	},

	methods: {
		logout () {
			this.$store.commit('isUserLoggedIn', false);
			this.$store.commit('isUserSignedUp', false);
			this.$store.commit('removeProductsFromFavourite');

			//Sign out from firebase
			/*
			firebase.auth().onAuthStateChanged(function(user) {
			if (user) {
				alert('User is signed in')
			} else {
				alert('No user is signed in.')
			}
			});
			*/

			firebase.auth().signOut().then(() => {
      			alert('logout done!')
    		})


			// redirect to homepage
			//this.$router.push({ name: 'home' });
		},
		showLoginModal () {
			this.$store.commit('showLoginModal', true);
		},
		showSignupModal () {
			this.$store.commit('showSignupModal', true);
		},
		signOut () {
			FirebaseAuth.getInstance().signOut();
		}
	}
}
</script>

<style scoped>
	.paddinglogo {
      padding-left : 0px;
	  padding-right : 10px;
    }

</style>


// WEBPACK FOOTER //
// src/components/signinlogin.vue